<template>
  <v-container fluid>
    <div class="text-h6 white--text d-md-none" style="margin-top: 10px;">Renovação das taxas</div>
    <div class="text-h6 black--text d-none d-md-block" style="margin-top: 10px;">Renovação das taxas</div>
    <div class="text-h6 indigo--text">Total das Taxas: R$ {{ totalTaxas | fmtNumber }}</div>
    <v-row>
      <v-col class="col-12 col-md-4" v-for="(itm, i) of carrinho" :key="i">
        <v-card>
          <v-card-text>
            <v-btn class="float-right" fab icon height="40px" right width="40px" @click="removeTaxa(itm.matricula, itm.convenio)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <div class="float-right font-weight-black">R$ {{ itm.valor | fmtNumber }}</div>
            <div>
              {{ itm.matricula }} - {{ getPessoa(itm.matricula).nome }}<br />
              {{ getConvenio(itm.convenio) }} {{ getChave(itm.chave) }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-h6 indigo--text">{{ carrinho.length }} taxas selecionadas</div>
    <div class="text-center" v-if="carrinho.length > 0">
      <v-btn class="" @click="finalizaPedido()">
        Finalizar
      </v-btn>
    </div>
    <div class="text-caption white--text d-md-none" style="margin-top: 10px;">Clique na taxa marcada em vermelho para renovar</div>
    <div class="text-caption black--text d-none d-md-block" style="margin-top: 10px;">Clique na taxa marcada em vermelho para renovar</div>
    <v-row>
      <v-card class="ma-2 col-12 col-md-4" :class="{ 'red lighten-4': socio.renovacao.socio.situacao !== 1 }">
        <v-row>
          <v-col cols="3">
            <v-avatar size="100px">
              <v-img :src="socio.renovacao.socio.foto" style="width: 120px" class="mx-auto" />
            </v-avatar>
          </v-col>
          <v-col>
            <div class="text-h6">{{ socio.renovacao.socio.nome }}</div>
            <div class="text-caption disabled">{{ socio.renovacao.socio.categoria_associado }}</div>
            <div v-if="socio.renovacao.socio.situacao === 1">
              <v-btn class="text-capitalize ma-2 white--text" :class="{
                'red':socio.renovacao.socio.vencido_carteira,
                'green':!socio.renovacao.socio.vencido_carteira,
                'orange': carrinho.filter(x => x.matricula === socio.matricula && x.convenio === 45)[0]
              }" @click="abreModal(socio.renovacao.socio, 1)">Carteirinha<br /> {{ socio.renovacao.socio.data_vencimento_carteira }}</v-btn>
              <v-btn class="text-capitalize ma-2 white--text" :class="{
                'red':socio.renovacao.socio.vencido_sanitaria,
                'green':!socio.renovacao.socio.vencido_sanitaria,
                'orange': carrinho.filter(x => x.matricula === socio.matricula && x.convenio === 5)[0]
              }" @click="abreModal(socio.renovacao.socio, 2)">Tx. Sanitária<br />{{ socio.renovacao.socio.data_vencimento_cartao_sanitario }}</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ma-2 col-12 col-md-4" v-for="(pessoa) in socio.renovacao.dependentes" :key="pessoa.matricula" :class="{ 'red lighten-4': pessoa.situacao !== 1 }">
        <v-row>
          <v-col cols="3">
            <v-avatar size="100px">
              <v-img :src="pessoa.foto" style="width: 120px" class="mx-auto" />
            </v-avatar>
          </v-col>
          <v-col>
            <div class="text-h6">{{ pessoa.nome }}</div>
            <div class="text-caption disabled">{{ pessoa.categoria_associado }}</div>
            <div v-if="pessoa.situacao === 1">
              <v-btn class="text-capitalize ma-2 white--text" :class="{
                'red':pessoa.vencido_carteira,
                'green':!pessoa.vencido_carteira,
                'orange': carrinho.filter(x => x.matricula === pessoa.matricula && x.convenio === 45)[0]
              }" @click="abreModal(pessoa, 1)">Carteirinha<br /> {{ pessoa.data_vencimento_carteira }}</v-btn>
              <v-btn class="text-capitalize ma-2 white--text" :class="{
                'red':pessoa.vencido_sanitaria,
                'green':!pessoa.vencido_sanitaria,
                'orange': carrinho.filter(x => x.matricula === pessoa.matricula && x.convenio === 5)[0]
              }" @click="abreModal(pessoa, 2)">Tx. Sanitária<br />{{ pessoa.data_vencimento_cartao_sanitario }}</v-btn>
            </div>
            <div v-else-if="pessoa.categoria == 'DEP EXT'">
              <v-btn class="red white-text text-capitalize ma-2 white--text" @click="abreModal(pessoa, 3)">Tx. Dependente Extraordinário<br />Anual</v-btn>
            </div>
            <div v-else class="text-center text-h6 red yellow--text ma-2 white--text">{{ pessoa.nSituacao }}</div>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
    <v-dialog v-model="modalCarteirinha">
      <v-card class="white">
        <div class="text-center text-h6 font-weight-black black--text">Renovação Carteirinha</div>
        <v-alert dense text class="ma-2 text-justify" type="success" v-if="!pessoaSelecionada.vencido_carteira">
          Suas taxas não estão vencidas mas você pode renovar, o prazo será adicionado ao vencimento atual e você não perderá nenhum dia de validade.
        </v-alert>
        <div class="pa-5">
        <v-btn class="mt-5 text-capitalize" color="primary" @click="selecionaTaxa(pessoaSelecionada.matricula, 45, '1ANO')">
          <v-col>Renovar por 1 ano</v-col>
          <v-col class="text-right font-weight-black">R$ {{ taxa(45, '1ANO') | fmtNumber }}</v-col>
        </v-btn>
        <v-btn class="mt-5 text-capitalize" color="orange" @click="selecionaTaxa(pessoaSelecionada.matricula, 45, '2ANOS')">
          <v-col>Renovar por 2 anos</v-col>
          <v-col class="text-right font-weight-black">R$ {{ taxa(45, '2ANOS') | fmtNumber }}</v-col>
        </v-btn>
        <div class="text-caption black--text">Esta opção já conta com um desconto de 15%</div>
        <v-btn class="mt-5 " color="default" @click="modalCarteirinha = false">
          Cancelar
        </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalSanitaria">
      <v-card class="white">
        <div class="text-center text-h6 font-weight-black black--text">Renovação Taxa Sanitária</div>
        <v-alert dense text class="ma-2 text-justify" type="success" v-if="!pessoaSelecionada.vencido_sanitaria">
          Suas taxas não estão vencidas mas você pode renovar, o prazo será adicionado ao vencimento atual e você não perderá nenhum dia de validade.
        </v-alert>
        <div class="pa-5">
        <v-btn class="mt-5 text-capitalize" color="primary" @click="selecionaTaxa(pessoaSelecionada.matricula, 5, 'M')">
          <v-col>Renovar por 1 mês</v-col>
          <v-col class="text-right font-weight-black">R$ {{ taxa(5, 'M') | fmtNumber }}</v-col>
        </v-btn>
        <v-btn class="mt-5 text-capitalize" color="orange" @click="selecionaTaxa(pessoaSelecionada.matricula, 5, 'T')">
          <v-col>Renovar por 5 meses</v-col>
          <v-col class="text-right font-weight-black">R$ {{ taxa(5, 'T') | fmtNumber }}</v-col>
        </v-btn>
        <div class="text-caption black--text">Esta opção é a mais vantajosa pelo prazo de utilização</div>
        <v-btn class="mt-5 " color="default" @click="modalSanitaria = false">
          Cancelar
        </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalExtraordinario">
      <v-card class="white">
        <div class="text-center text-h6 font-weight-black black--text">Dependente Extraordinário</div>
        <div class="pa-5">
          <div class="text-justify">
              O Valor da taxa já está inclusa a Carteira Social e Taxa Sanitária, a validade da inclusão do Dependente Extraordinário é de 1 ano.
          </div>
          <v-btn class="mt-5 text-capitalize" color="primary" @click="selecionaTaxa(pessoaSelecionada.matricula, 3, '')">
            <v-col>Dep Extraordinário</v-col>
            <v-col class="text-right font-weight-black">R$ {{ 535 | fmtNumber }}</v-col>
          </v-btn>
        <v-btn class="mt-5 " color="default" @click="modalExtraordinario = false">
        Cancelar
        </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['socio']),
    totalTaxas: function () {
      return this.carrinho.reduce((soma, x) => soma + x.valor, 0)
    }
  },
  data: () => ({
    remidos: ['USUVITA', 'PUD', 'REMIDO', 'REMOURO', 'THE', 'DIU', 'DIP'],
    modalCarteirinha: false,
    modalExtraordinario: false,
    modalSanitaria: false,
    taxas: [],
    pessoaSelecionada: {},
    taxaSelecionada: 0,
    carrinho: []
  }),

  mounted () {
    console.log('selcao', this.$store.getters.getTarifas)
    this.carrinho = Object.assign([], this.$store.getters.getTarifas)
  },
  methods: {
    finalizaPedido: function () {
      this.$store.commit('limpaCarrinho')
      this.$store.commit('updateCarrinhoTarifas', this.carrinho)
      this.$router.push('/pagamento/selecione')
    },
    taxa: function (convenio, chave) {
      const tx = this.socio.renovacao.tarifas.filter(x => x.convenio === convenio && x.chave === chave)[0]
      console.log(this.socio.renovacao.socio.categoria, this.remidos.includes(this.socio.renovacao.socio.categoria))
      if (this.remidos.includes(this.socio.renovacao.socio.categoria)) {
        return tx.valor_2
      } else {
        return tx.valor_1
      }
    },
    getPessoa: function (matricula) {
      if (this.socio.renovacao.socio.matricula === matricula) {
        return this.socio.renovacao.socio
      }
      return this.socio.renovacao.dependentes.filter(x => x.matricula === matricula)[0]
    },
    getConvenio: function (convenio) {
      switch (convenio) {
        case 45: return 'Renovação Carteira Social'
        case 5: return 'Renovação Taxa Sanitária'
        case 3: return 'Renovação Dependente Extraordinário'
      }
    },
    removeTaxa: function (matricula, convenio) {
      console.log(this.carrinho)
      this.carrinho = this.carrinho.filter(x => !(x.matricula === matricula && x.convenio === convenio))
    },
    getChave: function (chave) {
      switch (chave) {
        case '1ANO': return '1 Ano'
        case '2ANOS': return '2 Anos'
        case 'M': return 'Mensal'
        case 'T': return 'Temporada'
        default: return ''
      }
    },
    abreModal: function (pessoa, tipo) {
      this.pessoaSelecionada = pessoa
      switch (tipo) {
        case 1:
          this.modalCarteirinha = true
          break
        case 2:
          this.modalSanitaria = true
          break
        case 3:
          alert('Este dependente só pode ser atualizado na secretaria do clube')
          // this.modalExtraordinario = true
          break
      }
    },
    selecionaTaxa: function (matricula, convenio, chave) {
      let item = {}
      item = this.carrinho.filter(x => x.matricula === matricula && x.convenio === convenio)[0]
      if (item) {
        item.chave = chave
        item.valor = this.taxa(convenio, chave)
      } else {
        item = { matricula, convenio, chave, valor: this.taxa(convenio, chave) }
        this.carrinho.push(item)
      }
      this.modalSanitaria = false
      this.modalCarteirinha = false
      this.modalExtraordinario = false
    }
  }
}
</script>
